

import { BrowserRouter, Routes,Route,  } from 'react-router-dom';
import './App.css';
import Home from './components/Home/Home'
import Who_we_are from './components/Who_we_are/Who_we_are';
import How_we_support  from './components/How_we_support';
import Our_believe  from './components/Our_believe';
import Creed from './components/Creed';
import I_am_statement from './components/I_am_statement';
import Affirmation from './components/Affirmation';

import '../src/mainstyles.css'
import Programs from './components/Programs';
import Events from './components/Events';
import Emerald from './components/Emerald';
import Emerging_tech from './components/Emerging_tech';
import Contact_us from './components/Contact_us';
import About from './components/About';
import Pillars_of_impact from './components/Pillars_of_impact';
import Thematic_Areas from './components/Thematic_Areas';
import Climatic_change from './components/Climatic_change';
import Future_of_Food from './components/Future_of_Food'
import Improving_Crop_Productivity from './components/pages/Improving_Crop_Productivity'
import Sustainable_Energy from './components/Sustainable_Energy';
import Digitalization_Emerging_Technology from './components/Digitalization_Emerging_Technology';
import Nextechczar_Incubation_Program from './components/pages/Nextechczar_Incubation_Program';
import AI_low_resource from './components/pages/AI_low_resource';
import Advanced_generative_AI from './components/pages/Advanced_generative_AI';
import National_generative_AI from './components/pages/National_generative_AI';
import Data_Sovereignty from './components/pages/Data_Sovereignty ';
import Creative_sectors from './components/pages/Creative_sectors';
import WIRA from './components/pages/WIRA';
import Gender_focus_program from './components/pages/Gender_focus_program';
import IFF_investment from './components/pages/IFF_investment'
import IFF_annual_gathering from './components/pages/IFF_annual_gathering';
import GIZ_DTC from './components/pages/GIZ_DTC';
import Market_Access from './components/pages/Market_Access';
import Ai_programs_evaluation from './components/pages/ai_programs_evaluation';
import Meta_AI_LIama from './components/pages/Meta_AI_LIama';
import Research_to_commercialization from './components/pages/Research_to_commercialization';
import Research_to_commerce_toolkit from './components/pages/Research_to_commerce_toolkit';
import Lab_to_market from './components/pages/Lab_to_market';
import Partnership_giz_dtc from './components/pages/Partnership_giz_dtc';
import Pathway_2_scale from './components/pages/pathway_2_scale';
import AU_EU_dialogue from './components/pages/AU_EU_dialogue';
import Innovation_Fair from './components/pages/Innovation_Fair';
import DeepTech_Summit from './components/pages/DeepTech_Summit';
import NIIRIC_second_gathering from './components/pages/NIIRIC_second_gathering';
import Gitex_Nigeria from './components/pages/Gitex_Nigeria';
import Raw_materials_research from './components/pages/Raw_materials_research';






import NextechCzar_application from './components/NextechCzar_application';
import Reports from './components/Reports';

function App() {
  return (


   <BrowserRouter>
    <Routes>

      
    <Route  path="/" element={<Home />} />
    <Route  path="/about_us" element={<About />} />
    
    <Route  path="/pillars_of_impact" element={<Pillars_of_impact />} />
    
    <Route  path="/thematic_areas" element={<Thematic_Areas />} />
    
    <Route  path="/how_we_support" element={<How_we_support />} />

    
    <Route  path="/our_believe" element={<Our_believe />} />
    
    <Route  path="/creed" element={<Creed />} />

    
    <Route  path="/I_am_statement" element={<I_am_statement />} />

    
    <Route  path="/affirmation" element={<Affirmation />} />

    
    <Route  path="/programs" element={<Programs />} />
    
    <Route  path="/events" element={<Events />} />
    <Route  path="/emerald" element={<Emerald />} />
    
    <Route  path="/ermerging-tech" element={<Emerging_tech />} />
    
    <Route  path="/nextechCzar_application" element={<NextechCzar_application />} />

    
    <Route  path="/reports" element={<Reports />} />
    
    <Route  path="/contact_us" element={<Contact_us />} />
    
    <Route  path="/climatic_change" element={<Climatic_change />} />
    
    <Route  path="/future_of_food" element={<Future_of_Food />} />
    
    <Route  path="/Improving_Crop_Productivity" element={< Improving_Crop_Productivity />} />
    
    <Route  path="/sustainable_energy" element={< Sustainable_Energy />} />
    
    <Route  path="/digitalization_emerging_Technology" element={< Digitalization_Emerging_Technology />} />
    
    <Route  path="/Nextechczar_Incubation_Program" element={< Nextechczar_Incubation_Program/>} />

    
    <Route  path="/AI_low_resource" element={<AI_low_resource/>} />
    
    <Route  path="/advanced_generative_AI" element={<Advanced_generative_AI/>} />
    
    <Route  path="/national_generative_AI" element={<National_generative_AI/>} />
    
    <Route  path="/data_Sovereignty" element={<Data_Sovereignty/>} />
     <Route  path="/creative_sectors" element={<Creative_sectors/>} />
     
     <Route  path="/wira" element={<WIRA/>} />
     
     <Route  path="/gender_focus_program" element={<Gender_focus_program/>} />
     
     <Route  path="/iff_investment" element={<IFF_investment/>} />
     <Route  path="/iff_annual_gathering" element={<IFF_annual_gathering/>} />

     <Route  path="/giz_dtc" element={<GIZ_DTC/>} />
     <Route  path="/market_access" element={<Market_Access/>} />

     
     <Route  path="/ai_programs_evaluation" element={<Ai_programs_evaluation/>} />

     
     <Route  path="/meta_AI_LIama" element={<Meta_AI_LIama/>} />

     
     <Route  path="/research_to_commercialization" element={<Research_to_commercialization/>} />

     
     <Route  path="/research_to_commerce_toolkit" element={<Research_to_commerce_toolkit/>} />

     
     <Route  path="/lab_to_market" element={<Lab_to_market/>} />
     
     <Route  path="/partnership_giz_dtc" element={<Partnership_giz_dtc/>} />
     
     <Route  path="/pathway_2_scale" element={<Pathway_2_scale/>} />
     
     <Route  path="/aU_EU_dialogue" element={<AU_EU_dialogue/>} />

     
     <Route  path="/innovation_Fair" element={<Innovation_Fair/>} />

     
     <Route  path="/deepTech_Summit" element={<DeepTech_Summit/>} />
     
     <Route  path="/iff_annual_gathering" element={<IFF_annual_gathering/>} />
     
     <Route  path="/NIIRIC_second_gathering" element={<NIIRIC_second_gathering/>} />
     
     <Route  path="/gitex_Nigeria" element={<Gitex_Nigeria/>} />

     
     <Route  path="/raw_materials_research" element={<Raw_materials_research/>} />

     

     

     

     

     

     

     


     

     


     

     


     

     

     
     
     


     


     
     


     
     

    

    
    


    
    

    
    
   

    

    

    


    


    

    
    




      </Routes>
      </BrowserRouter>



  );
}

export default App;
